export const cibUikit = ["32 32","<path d='M23.594 4.391l-5.474 3.318 6.313 3.594v9.438l-8.484 4.719-8.344-4.719v-7.313l-5.474-2.818v13.391l13.625 8 14.115-8v-15.995zM21.057 3.073l-5.307-3.073-5.531 3.422 5.375 2.958z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/brand/cib-uikit.js
// module id = null
// module chunks = 